import { Row, Col, Typography, Divider } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './style.module.css';

const { Title, Text, Paragraph } = Typography;

interface Feature {
  icon: string;
  title: string;
  desc: string;
}

const HistoryCard: React.FC = () => {
  const { t } = useTranslation();

  const features = t('history.features', { returnObjects: true }) as Feature[];

  return (
    <div className={styles.wrapper}>
      <Title level={2} className={styles.heading}>
        {t('history.heading')}
      </Title>

      <Row gutter={[32, 32]} align="middle">
        <Col xs={24} md={10}>
          <img src={t('history.image')} loading="lazy" width={1200} height={1800} alt={t('history.imageAlt')} className={styles.image} />
        </Col>

        <Col xs={24} md={14}>
          <Title level={3} className={styles.intro}>
            {t('history.intro')}
          </Title>

          <ul className={styles.list}>
            {features.map((f, i) => (
              <li key={i} className={styles.listItem}>
                <Text strong className={styles.listItemTitle}>
                  <span role="img" aria-label="icon">
                    {f.icon}
                  </span>{' '}
                  {f.title}
                </Text>
                {' — '}
                <Text>{f.desc}</Text>
              </li>
            ))}
          </ul>

          <Paragraph className={styles.outro}>{t('history.outro')}</Paragraph>
        </Col>
      </Row>

      <Divider />
    </div>
  );
};

export default HistoryCard;
